export default __webpack_public_path__ + "static/mis_preparations-1b3cd8b7b1d520f7612f315058c2ed12.png";